/* import __COLOCATED_TEMPLATE__ from './permissions-panel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();